import { ApiService } from "./apiService"


export const getPlans = async () => {
    return ApiService.get(`plans`);
}

export const getCurrentPlan = async () => {
    return ApiService.get('plans/current-plan');
}

export const getNextPlan = async () => {
    return ApiService.get('plans/next-plan');
}